import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './Chapters.css';
import Languages from './Languages';
import HAPPYFAMILY from '../images/HAPPYFAMILY.webp';
import GENERALCHAP from '../images/ATRIIMG.png';
import SIBLINGS from '../images/SIBLINGS.jpg';
import PROPERTY from '../images/PROPERTY.jpg';
import PRGNANT from '../images/PRGNANT.avif';
import HEALTHY from '../images/HEALTHY.jpg';
import MARRIAGE from '../images/MARRIAGE.jpg';
import HUMANGROW from '../images/HUMANGROW.jpg';
import COINFALLING from '../images/COINFALLING.jpg';
import BUSINESSIMG from '../images/BUSINESSIMG.jpg';
import MONEYPROFIT from '../images/MONEYPROFIT.avif';
import TRADITIONALMECINE from '../images/TRADITIONALMECINE.avif';
import TRIPWAIT from '../images/TRIPWAIT.jpg';
import BIRTHSIN from '../images/BIRTHSIN.jpg';
import SOLARSYSTEM from '../images/SOLARSYSTEM.jpg';
import JEPAMANTRA from '../images/JEPAMANTRA.jpeg';

export default function Chapters() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const chapters = [
    { img: GENERALCHAP, title: 'Chapter 1: General Overview (Janma Kandam)', desc: "Offers a summary of the individual's life, including name, parents, spouse, and siblings. Highlights career, health, and family predictions." },
    { img: HAPPYFAMILY, title: 'Chapter 2: Family, Wealth, and Education (Kutumba Kandam)', desc: 'Details financial prospects, income, expenses, education level, and family relationships.' },
    { img: SIBLINGS, title: 'Chapter 3: Siblings (Sahodara Kandam)', desc: 'Describes the relationship with siblings, their prosperity, and support.' },
    { img: PROPERTY, title: 'Chapter 4: Mother, Assets, and Happiness (Matrukara Kandam)', desc: "Explores the mother's well-being, property inheritance, and mental peace." },
    { img: PRGNANT, title: 'Chapter 5: Children and Progeny (Santana Kandam)', desc: 'Focuses on childbirth, the health of children, and their future.' },
    { img: HEALTHY, title: 'Chapter 6: Health and Enemies (Roga and Runa Kandam)', desc: 'Covers health issues, debts, and enemies, offering remedies to overcome challenges.' },
    { img: MARRIAGE, title: 'Chapter 7: Marriage (Kalathra Kandam)', desc: "Delves into marriage life, compatibility, spouse's character, and happiness." },
    { img: HUMANGROW, title: 'Chapter 8: Longevity and Accidents (Ayul Kandam)', desc: 'Discusses life span, unexpected accidents, and remedies to ensure safety.' },
    { img: COINFALLING, title: 'Chapter 9: Father, Wealth, and Spirituality (Pithru Kandam)', desc: "Covers the father's health, wealth accumulation, and spiritual inclinations." },
    { img: BUSINESSIMG, title: 'Chapter 10: Profession and Business (Karma Kandam)', desc: 'Provides insights into career growth, profession, and business success.' },
    { img: MONEYPROFIT, title: 'Chapter 11: Profits and Second Marriage (Labha Kandam)', desc: 'Analyzes financial gains and prospects of a second marriage, if applicable.' },
    { img: TRIPWAIT, title: 'Chapter 12: Losses and Expenditure (Viraya Kandam)', desc: 'Predicts losses, expenses, and provides remedies to balance financial struggles.' },
    { img: BIRTHSIN, title: 'Chapter 13: Santhi Pariharam', desc: "Last birth sins committed, remedial measures to get rid of the effects of past life's sins." },
    { img: JEPAMANTRA, title: 'Chapter 14: Deeksha Kandam', desc: 'Mantra Japam, wearing of Raksha (Talisman) to avoid troubles and enemies.' },
    { img: TRADITIONALMECINE, title: 'Chapter 15: Aushadha Kandam', desc: 'Medicines for long-standing diseases and the method of taking them.' },
    { img: SOLARSYSTEM, title: 'Chapter 16: Dasabukhthi Kandam', desc: 'Prediction for the running Disa Bukthi (Major sub-period).' },
  ];

  return (
    <>
      <Navbar />
      <section id="nadi-astrology">
        <h2>The 16 Chapters of Nadi Astrology: A Detailed Insight</h2>
        <p className="intro">
          Nadi Astrology provides intricate insights into various aspects of life, guiding individuals with remedies and understanding past, present, and future lives. Explore the detailed chapters below.
        </p>

        {chapters.map((ch, index) => (
          <div className="chapter" key={index}>
            <div className="chapter-img">
              <img src={ch.img} alt={ch.title} />
            </div>
            <div className="chapter-content">
              <h3>{ch.title}</h3>
              <p>{ch.desc}</p>
              <a href="tel:+917402167580">
                <button className="appointment-btn">Get Appointment</button>
              </a>
            </div>
          </div>
        ))}
      </section>
      {/* <Footer /> */}
    </>
  );
}
